









export default {
	props:{
		opacity:{
			type:Number,
			default:0
		},
		color:{
			type:String,
			default:"#ffffff"
		}
	}
}
